import { useTranslation } from 'react-i18next';

import { OrderFormProductDTO } from 'support/types';

type ProductPartsInfoProps = {
  product: OrderFormProductDTO;
  partsCount: number;
};

export function ProductPartsInfo({ product, partsCount }: ProductPartsInfoProps) {
  const { t } = useTranslation();

  return t('orderForms:form.product.partsPerUnit', {
    unit: t(`common:unitOfMeasure.${product.unit_of_measure}`),
    childUnit: product.parts?.[0]?.unit_of_measure
      ? t(`common:unitOfMeasure.${product.parts[0].unit_of_measure}`)
      : undefined,
    count: partsCount,
  });
}

/**
 * t('common:unitOfMeasure.EA')
 * t('common:unitOfMeasure.GRM')
 * t('common:unitOfMeasure.HUR')
 * t('common:unitOfMeasure.KGM')
 * t('common:unitOfMeasure.LTR')
 * t('common:unitOfMeasure.MLT')
 * t('common:unitOfMeasure.MTK')
 * t('common:unitOfMeasure.MTR')
 * t('common:unitOfMeasure.PCK')
 * t('common:unitOfMeasure.SET')
 * t('common:unitOfMeasure.CS')
 * t('common:unitOfMeasure.CA')
 * t('common:unitOfMeasure.DAY')
 * t('common:unitOfMeasure.WEE')
 * t('common:unitOfMeasure.MON')
 * t('common:unitOfMeasure.CT')
 * t('common:unitOfMeasure.CQ')
 * t('common:unitOfMeasure.CU')
 * t('common:unitOfMeasure.BJ')
 * t('common:unitOfMeasure.BO')
 * t('common:unitOfMeasure.MTQ')
 * t('common:unitOfMeasure.PF')
 * t('common:unitOfMeasure.BG')
 * t('common:unitOfMeasure.RO')
 * t('common:unitOfMeasure.TNE')
 * t('common:unitOfMeasure.BE')
 * t('common:unitOfMeasure.CMT')
 * t('common:unitOfMeasure.KMT')
 * t('common:unitOfMeasure.PR')
 * t('common:unitOfMeasure.TU')
 * t('common:unitOfMeasure.COL')
 */
